/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash';
import Backgrid from 'backgrid';

import tmplLinkCell from './LinkCell.hbs';

/**
 * Cell that displays a link and/or surrounding text.
 * @property {string?} emptyText - Link text to display if name is undefined.
 * @property {string?} href - The address to link to, if any.
 * @property {string?} name - The link text.
 * @property {boolean?} newTab - Whether the link should open a new tab when clicked.
 * @property {string?} textTemplate - Plain text to display before and/or after the link.
 * May contain one `{link}` placeholder which will be replaced by the link.
 * If the placeholder is absent, the link will be appended after the text.
 */
const LinkCell = Backgrid.Cell.extend({
  className: 'link-cell',

  render() {
    let href, leadingText, trailingText;

    if (this.href) {
      href = Backgrid.callByNeed(this.href, this, this.model);
    }
    if (this.textTemplate) {
      const template = Backgrid.callByNeed(this.textTemplate, this, this.model);
      [leadingText, trailingText] = template.split("{link}", 2);
    }

    this.$el.addClass(this.column.get('name'));
    const emptyText = this.column.get('emptyText') || '--';
    this.$el.empty().append(
      tmplLinkCell({
        name: _.isFunction(this.name) ? this.name.bind(this) : this.name,
        newTab: this.newTab,
        href,
        leadingText,
        trailingText,
        emptyText
      })
    );

    this.delegateEvents();
    return this;
  }
});

export default LinkCell;
